import { createFileRoute, redirect } from '@tanstack/react-router'
import { RegisterPage } from '@/spa/pages/RegisterPage'
import { canShowSignupUi } from '@/lib/purchase-surface'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/register')({
  // Reachable natively too: creating a free account names no price and is not
  // a purchase. Keeping it web-only turned the app into a dead end for anyone
  // who installed it before signing up. See canShowSignupUi() for the bet and
  // the one-line way back if App Review disagrees.
  beforeLoad: () => {
    if (!canShowSignupUi()) throw redirect({ to: '/login' })
  },
  component: RegisterPage,
  errorComponent: routeErrorComponent,
})
